import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";

import { setPageTitle } from "../../redux/slice/pageTitleSlice";
import ReturnList from "./ReturnList";

const ManageReturnList = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setPageTitle("Return List"));
  }, []);

//   const { pageAccess } = useSelector((state) => state.user);

  const [activeToggle, setActiveToggle] = useState("returnlist");

  //   return checkPageAccess(pageAccess, allPages?.order, allCrudNames?.read) ? (
  //     <>
  //       <div className='card overflow-hidden'>
  //         <div className='card-body p-0'>
  //           <div className='nav-tabs-horizontal nav nav-tabs'>
  //             {checkPageAccess(
  //               pageAccess,
  //               allPages?.order,
  //               allCrudNames?.read
  //             ) && (
  //               <Link
  //                 onClick={() => setActiveToggle('order')}
  //                 data-toggle='tab'
  //                 className={`nav-link fw-semibold ${
  //                   activeToggle === 'order' ? 'active show' : ''
  //                 }`}
  //               >
  //                 <span className='nav-span'>
  //                   Order
  //                   <hr />
  //                 </span>
  //               </Link>
  //             )}
  //           </div>

  //           <div className='tab-content p-3'>
  //             {checkPageAccess(
  //               pageAccess,
  //               allPages?.order,
  //               allCrudNames?.read
  //             ) && (
  //               <div
  //                 id='order'
  //                 className={`tab-pane fade ${
  //                   activeToggle === 'order' ? 'active show' : ''
  //                 }`}
  //               >
  //                 {activeToggle === 'order' && <MainOrder />}
  //               </div>
  //             )}
  //           </div>
  //         </div>
  //       </div>
  //     </>
  //   ) : (
  //     <NotFound />
  //   )
  return (
    <div className="card overflow-hidden">
      <div className="card-body p-0">
        <div className="nav-tabs-horizontal nav nav-tabs">
          <Link
            onClick={() => setActiveToggle("returnlist")}
            data-toggle="tab"
            className={`nav-link fw-semibold ${
              activeToggle === "returnlist" ? "active show" : ""
            }`}
          >
            <span className="nav-span">
              Return List
              <hr />
            </span>
          </Link>
        </div>

        <div className="tab-content p-3">
          <div
            id="returnlist"
            className={`tab-pane fade ${
              activeToggle === "returnlist" ? "active show" : ""
            }`}
          >
            {activeToggle === "returnlist" && <ReturnList />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManageReturnList;
